// Per-branch feature flags.
//
// Set this to true on a customer branch that needs assessment tasks.
export const ENABLE_ASSESSMENT = true;

// flip this to true if customers use a custom progress calculation
export const ENABLE_CUSTOM_PROGRESS = false;

// flip this to true if customers use a custom progress calculation
export const ENABLE_ACADEMY_147_PDF = false;